/* Developed by: Philip C. Diaz
   Passion: Javascript Prototype Developer | Senior Frontend Developer
   Website: https://philipdiaz.info
   Email: diazphi@gmail.com

   License: Forever Free, you are freely to improve and modify.
*/      
"use strict";
window.theme = window.theme || {}
theme.HeaderSloganAnimation = function() {

    function HeaderSloganAnimation() {
        this.header = {
           horse_image: document.querySelector('.header_horse_image'),
           social_icons: document.querySelector('.header-social-links')
        }
        this.load();
    }

    HeaderSloganAnimation.prototype.load = function() {
        var _ = this; 
        var lastScrollTop = 0;
        window.onscroll = event => {
            var st = window.pageYOffset;
            if (st > lastScrollTop){
                _.header.horse_image.style.setProperty('display','none');
                _.header.social_icons.style.setProperty('display','none');
             } else {
                _.header.horse_image.style.setProperty('display','block');
                _.header.social_icons.style.setProperty('display','block');
             }
             lastScrollTop = st <= 0 ? 0 : st; 
        }         
    }

  theme.HeaderSloganAnimation = new HeaderSloganAnimation;

}

theme.HeaderSloganAnimation();